import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import gtagAPI from '../apis/gtag.js'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/index',
      name: 'Index',
      component: Index,
    },
    {
      path: '/select',
      name: 'Select',
      component: () => import('../views/Select.vue'),
    },
    {
      path: '/ar-link',
      name: 'ARLink',
      component: () => import('../views/ARLink.vue'),
      beforeEnter: (to, from, next) => {
        // 簡易防止非正規進入
        const { card_id, name } = to.query
        if (!card_id || !name) return next('/')
        next()
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('../views/Privacy.vue'),
    },
    {
      path: '*',
      redirect: '/index',
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  gtagAPI.sendPageView(to.path)
  next()
})

export default router
